import { defineMessages } from "react-intl"

export default defineMessages({
  cancel: {
    defaultMessage: "Cancel",
    id: "src.components.MenuBar.cancel",
  },
  logout: {
    defaultMessage: "Logout",
    id: "src.components.MenuBar.logout",
  },
  logoutConfirm: {
    defaultMessage: "Are you sure you want to logout?",
    id: "src.components.MenuBar.logoutConfirm",
  },
})
